import styled, { css } from 'styled-components';
import { BG_TEXT } from '../../settings';

const fullStyles = css`
  width: 100%;
`;

const ContentWrapper = styled.div`
  flex-grow: 1;
  min-height: calc(100vh - 60px);
  width: calc(100% - 220px);
  background-color: #f3f9f9;
  padding: 20px 35px;
  background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' height='64px' width='128px'><text text-anchor='middle' x='64' y='40' fill='rgba(0,0,0,0.08)' transform='rotate(335,64,32)' font-size='24'>${BG_TEXT}</text></svg>");

  @media (max-width: 768px) {
    min-height: calc(100vh - 60px);
  }

  @media (max-width: 576px) {
    padding: 10px;
  }

  ${p => p.full && fullStyles};

  img.dollar-icon {
    width: 30px;
    height: 30px;
    vertical-align: middle;
  }

  .top-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .page-title {
      display: flex;
      align-items: center;
      .title-icon {
        width: 44px;
        height: 44px;
        background-color: #e0f5f4;
        color: #44cbbd;
        margin-right: 14px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    .header-icons-wrapper {
      display: flex;
      justify-content: space-between;
    }
    .icon-wrapper {
      width: 44px;
      height: 44px;
      border-radius: 50%;
      background-color: #fff;
      border: 1px solid #dddddd;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 11px;
      color: #7f7f7f;
      cursor: pointer;
      img {
        width: 17px;
        height: 17px;
      }
    }
  }
`;

export default ContentWrapper;



// WEBPACK FOOTER //
// ./src/components/common/ContentWrapper.js